import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ArticleDesign, ArticleDisplay, ArticlePillar } from '@guardian/libs';
import { RichLink } from '@root/src/web/components/RichLink';
const defaultImageData = {
    thumbnailUrl: '',
    altText: '',
    width: '',
    height: '',
};
export const DefaultRichLink = ({ index, headlineText, url, isPlaceholder, }) => {
    return (_jsx(RichLink, { richLinkIndex: index, cardStyle: "news", imageData: defaultImageData, headlineText: headlineText, contentType: "article", url: url, format: {
            display: ArticleDisplay.Standard,
            design: ArticleDesign.Standard,
            theme: ArticlePillar.News,
        }, tags: [], sponsorName: "", isPlaceholder: isPlaceholder }, void 0));
};
